import { FormikErrors } from 'formik';

import { PathSelector } from '@/react/portainer/gitops/ComposePathField/PathSelector';
import { GitFormModel } from '@/react/portainer/gitops/types';

import { FormSection } from '@@/form-components/FormSection';
import { FormControl } from '@@/form-components/FormControl';
import { TextTip } from '@@/Tip/TextTip';

import { FormValues } from '../types';

interface Props {
  chartPath: string;
  gitModel: GitFormModel;
  errors: FormikErrors<FormValues>;
  onChartPathChange: (value: string) => void;
}

export function HelmChartPathSection({
  chartPath,
  gitModel,
  errors,
  onChartPathChange,
}: Props) {
  return (
    <FormSection title="Helm chart">
      <TextTip color="blue" className="mb-3">
        Set the path to the Helm chart folder. Only the Git repository can be
        used as a Helm chart source for now. To use an OCI registry or Helm
        repository, use Helm without Git.
      </TextTip>

      <FormControl
        label="Helm chart path"
        errors={errors.helmChartPath}
        required
        tooltip="Indicate the path to the Helm chart folder from the root of your repository. The folder must contain a Chart.yaml file."
      >
        <PathSelector
          value={chartPath}
          onChange={onChartPathChange}
          placeholder="e.g. charts/my-app"
          model={gitModel}
          dirOnly
          allowEmpty={false}
          inputId="helm-chart-path"
          hasError={!!errors.helmChartPath}
        />
      </FormControl>
    </FormSection>
  );
}
